import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiEmailService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  sendEmail(data:any){
    return this.http.post(`${this.baserApiUrl}email`,data)
  }

  
}
